import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KButtonModule } from 'app/common/ui/k-button/k-button.module';
import { BadgeModule } from 'primeng/badge';
import { TranslocoModule } from '@ngneat/transloco';
import { DirectivesModule } from 'app/common/directives/directives.module';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    OverlayPanelModule,
    KButtonModule,
    FontAwesomeModule,
    BadgeModule,
    TranslocoModule,
    DirectivesModule,
    RouterModule
  ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule { }
